import { render } from "./ScriptsComponent.vue?vue&type=template&id=0592f1d5"
import script from "./ScriptsComponent.vue?vue&type=script&lang=js"
export * from "./ScriptsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__